import Widgets from 'js-widget-hooks';

Widgets.register('show-more',
    /**
     * @param {Element} el
     */
    function(el){
        let detail = el.querySelector('.event-line__details');
        let theLink = el.querySelector('.target--more');

        el.addEventListener('click', function(){
            if (detail.classList.contains('show')) {
                detail.classList.remove('show');

                theLink.innerHTML = el.dataset.more
            } else {
                detail.classList.add('show');
                theLink.innerHTML = el.dataset.less;
            }
        })
    }
);